interface Props {
  auctionStartFormatted: any
  auctionStartCountdown: any
}

const MintingCountdown = ({ auctionStartFormatted, auctionStartCountdown }: Props) => {
  return (
    <p className="text-sm font-medium text-gallery-text mb-2">
      Live: {auctionStartFormatted} ({auctionStartCountdown})
    </p>
  )
}

export default MintingCountdown
